import styled from "styled-components";

export const IconCheck = styled.svg`
  width: 20px;
  height: 20px;
  fill: #fff;

  @media (min-width: 1440px) {
    width: 30px;
    height: 30px;
  }
`;

export const UndoneIcon = styled.svg`
  width: 16px;
  height: 16px;

  @media (min-width: 428px) {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 744px) {
    width: 30px;
    height: 30px;
  }
`;
